import React from 'react'
import { Grid, Image, H, P, Button, Wrapper } from '@farewill/ui'

import { TELEPHONE_WILLS_APPOINTMENT_BOOKING_URL } from 'config'
import { trackEvent } from 'lib/tracking'
import PreventOrphan from 'components/PreventOrphan'

const trackButtonClick = () => {
  trackEvent('Book callback button (Telephone Wills)', 'click')
}

type TelephoneSectionProps = {
  title?: string
  children?: React.ReactNode
}

const TelephoneSection = ({
  title,
  children,
}: TelephoneSectionProps): React.ReactElement => (
  <Grid container style={{ alignItems: 'center' }}>
    <Grid.Item spanFromM={4} spanFromL={3} centered centeredFromM={false}>
      <Image
        path="illustrations/coordinator-white-paper-yellow-phone"
        width={200}
        widthFromL={300}
        stretch
      />
    </Grid.Item>
    <Grid.Item spanFromM={8} spanFromL={9}>
      <H size="L" as="h2" decorative>
        <PreventOrphan>
          {title || 'You can also make a will over the phone'}
        </PreventOrphan>
      </H>
      <Wrapper margin={[0, 0, 'L']} maxWidthInColumns={7}>
        {children || (
          <P>
            If you don’t feel confident writing a will online, one of our
            specialists would be happy to make your will over the phone. We can
            then get it printed, bound and sent out to you in the post. Book a
            free callback to get started.
          </P>
        )}
      </Wrapper>
      <Button.BorderedDark
        href={TELEPHONE_WILLS_APPOINTMENT_BOOKING_URL}
        onClick={trackButtonClick}
      >
        Book a free call back
      </Button.BorderedDark>
    </Grid.Item>
  </Grid>
)

export default TelephoneSection
